/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pTokenFrom.vue?vue&type=template&id=30d8e4c9"
import script from "./pTokenFrom.vue?vue&type=script&lang=js"
export * from "./pTokenFrom.vue?vue&type=script&lang=js"
import style0 from "./pTokenFrom.vue?vue&type=style&index=0&id=30d8e4c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports